import React, { useState, useEffect, useRef } from 'react';
import styles from './style.module.css';

import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import apiZelo from '../../services/backAxiosVendaToken';
import { ProgressSpinner } from 'primereact/progressspinner';

const PagarComPix = props => {
    const formatCurrency = value => value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });

    const Inscricao = props.inscricao;
    const [qrValue, setQrValue] = useState('');
    const [viewsQrCode, setViewsQrCode] = useState(false);
    const valorFormatado = formatCurrency(parseFloat(qrValue.valor));

    useEffect(() => {
        (async () => {
            try {
                const response = await apiZelo.post(`/pagamentos/pix/adesao/${Inscricao}`);

                if (response.status === 200) {
                    setQrValue(response.data);
                    setViewsQrCode(true);
                }
            } catch (error) {
                mostrarMensagemErro();
                setTimeout(() => {
                    document.location.reload();
                }, 3000);

                return error.message;
            }
        })();
    }, []);

    const mensagemSucesso = useRef(null);

    function mostrarMensagemSucesso() {
        mensagemSucesso.current.show({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Código copiado com sucesso',
            life: 3000
        });
    }

    const mensagemErro = useRef(null);

    function mostrarMensagemErro() {
        mensagemErro.current.show({
            severity: 'error',
            summary: 'Erro',
            detail: 'Pagamento já realizado ou inscrição não encontrada',
            life: 3000
        });
    }

    const copyToClipBoard = () => {
        const text = document.getElementsByClassName('p-inputtextarea')[0];

        text.select();
        text.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(text.value);
        mostrarMensagemSucesso();
    };

    return (
        <>
            {viewsQrCode ? (
                <div>
                    <div>
                        <h6 className= {styles.h6} >O valor da adesão a ser pago é: {valorFormatado}</h6>
                    </div>
                    <div className="flex">
                        <img className = {styles.imgQr}  alt='Qr code' src={qrValue.image} />
                    </div>
                    <InputTextarea
                        rows={4}
                        cols={20}
                        value= {qrValue.code}
                        onChange={e => this.updatedField(e)}
                        autoResize
                    />
                    <Button cursor="pointer" label="Copiar" icon="pi pi-copy" onClick={() => copyToClipBoard()} />
                    <Growl ref={mensagemSucesso}/>
                </div>
            ) : (
                <>
                    <Growl ref={mensagemErro}/>
                    <div className = {styles.containerLoading}>
                        <ProgressSpinner className = {styles.loading} />
                    </div>
                </>
            )}
        </>

    );
};

export default PagarComPix;
